import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex, Box } from 'reflexbox/styled-components'
import { useStaticQuery, graphql } from 'gatsby'

import theme from 'theme'

import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  RedditShareButton,
  RedditIcon,
  TwitterShareButton,
  TwitterIcon,
} from 'react-share'

import Tooltip from '@anvilco-pkg/ui/components/Tooltip'

const getAttrs = ({ mt, mb }) => ({
  width: [1],
  flexDirection: ['column-reverse', 'column-reverse', 'row'],
  justifyContent: ['flex-start', 'flex-start', 'space-between'],
  alignItems: ['flex-start', 'flex-start', 'flex-end'],
  mt,
  mb,
})

const ShareContainer = styled(Flex).attrs(getAttrs)``

const ShareButtonContainer = styled(Box).attrs({})`
  color: ${'#FFFFFF'};
  max-height: 26px;

  svg rect {
    fill: ${theme.colors.black};
  }

  .linkedin {
    &:hover {
      stroke,
      svg rect {
        fill: ${'#007fb1'};
      }

      stroke-width: 5;
    }
  }

  .twitter {
    &:hover {
      stroke,
      svg rect {
        fill: ${'#00aced'};
      }
      stroke-width: 5;
    }
  }

  .reddit {
    stroke,
    &:hover {
      svg rect {
        fill: ${'#ff4500'};
      }
    }
    stroke-width: 5;
  }

  .facebook {
    &:hover {
      stroke,
      svg rect {
        fill: ${'#3b5998'};
      }
      stroke-width: 5;
    }
  }

  .email {
    &:hover {
      stroke,
      svg rect {
        fill: ${theme.colors.green};
      }

      stroke-width: 5;
    }
  }
`

const ButtonsContainer = styled(Flex).attrs({
  justifyContent: 'space-between',
  alignItems: 'center',
})`
  width: 100%;
  max-width: 250px;
`

const SocialShareButtons = ({
  title: postTitle,
  summary,
  path,
  bottomAction,
  ...others
}) => {
  const {
    site: {
      siteMetadata: { siteUrl },
    },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)

  const url = `${siteUrl}${path}`

  const title = `Check out this blog post from Anvil: ${postTitle}`
  return (
    <ShareContainer {...others}>
      {bottomAction && bottomAction()}
      <ButtonsContainer>
        <ShareButtonContainer>
          <Tooltip placement="bottom" trigger="hover" title="Share on Linkedin">
            <LinkedinShareButton
              url={url}
              title={title}
              summary={summary}
              source="https://www.useanvil.com/blog"
              className="linkedin"
            >
              <LinkedinIcon size={26} borderRadius={8} />
            </LinkedinShareButton>
          </Tooltip>
        </ShareButtonContainer>
        <ShareButtonContainer>
          <Tooltip placement="bottom" trigger="hover" title="Share on Twitter">
            <TwitterShareButton
              url={url}
              title={title}
              related={['@AnvilFoundry', '@manggit']}
              hashtags={['pdf', 'nocode', 'api']}
              className="twitter"
            >
              <TwitterIcon size={26} borderRadius={8} />
            </TwitterShareButton>
          </Tooltip>
        </ShareButtonContainer>
        <ShareButtonContainer>
          <Tooltip placement="bottom" trigger="hover" title="Share on Reddit">
            <RedditShareButton url={url} title={title} className="reddit">
              <RedditIcon size={26} borderRadius={8} />
            </RedditShareButton>
          </Tooltip>
        </ShareButtonContainer>
        <ShareButtonContainer>
          <Tooltip placement="bottom" trigger="hover" title="Share on Facebook">
            <FacebookShareButton
              url={url}
              title={title}
              quote={summary}
              className="facebook"
            >
              <FacebookIcon size={26} borderRadius={8} />
            </FacebookShareButton>
          </Tooltip>
        </ShareButtonContainer>
        <ShareButtonContainer>
          <Tooltip placement="bottom" trigger="hover" title="Share via email">
            <EmailShareButton
              url={url}
              subject={`Anvil Blog: ${postTitle}`}
              body={`${postTitle} \n----\n ${summary} \n\n`}
              className="email"
              // issue with the lib: https://github.com/nygardk/react-share/issues/419
              onClick={(_, link) => {
                window.location.href = link // does the same as the default onClick
              }}
            >
              <EmailIcon size={26} borderRadius={8} />
            </EmailShareButton>
          </Tooltip>
        </ShareButtonContainer>
      </ButtonsContainer>
    </ShareContainer>
  )
}

export default SocialShareButtons

SocialShareButtons.propTypes = {
  frontmatter: PropTypes.object,
  url: PropTypes.string,
  bottomAction: PropTypes.func,
}
